<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>
  
  <script>
import * as echarts from 'echarts';
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '420px',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    lineXData: {
      type: Array,
      default: [],
    },
    lineYData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chart: null,
      sidebarElm: null,
      chartData: {
        visitsData: [],
        ipData: [],
      },
      weekDays: [],
    };
  },
  mounted() {
    this.initChart();

    if (this.autoResize) {
      this.__resizeHandler = this._.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHandler);
    }

    // 监听侧边栏的变化
    this.sidebarElm = document.getElementsByClassName('sidebar-container')[0];
    this.sidebarElm && this.sidebarElm.addEventListener('transitionend', this.sidebarResizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler);
    }

    this.sidebarElm && this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler);

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === 'width') {
        this.__resizeHandler();
      }
    },
    setOptions() {
      this.chart.setOption(
        {
          dataZoom: [
            {
              type: 'inside', //1平移 缩放
              throttle: '50', //设置触发视图刷新的频率。单位为毫秒（ms）。
              minValueSpan: 6, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
              start: 1, //数据窗口范围的起始百分比 范围是：0 ~ 100。表示 0% ~ 100%。
              end: 50, //数据窗口范围的结束百分比。范围是：0 ~ 100。
              zoomLock: true, //如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放。
            },
          ],
          tooltip: {
            trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
            backgroundColor: '#fff', //提示框浮层的背景颜色。
            formatter: '{b}  <br/> {c}次',
            axisPointer: {
              //去掉移动的指示线
              type: 'none',
            },
          },
          grid: {
            show: false,
            top: "40px",
            bottom:"50px"
          },
          xAxis: {
            type: 'category',
            data: this.lineXData,
            axisTick: {
              show: false, //隐藏刻度线
            },
            splitLine: {
              //去除网格线
              show: true,
            },
            axisLine: {
              show: false, //隐藏y轴
              lineStyle: {
                color: '#999999',
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#999999',
              },
            },
            splitArea: { show: false }, //去除网格区域
            splitLine: {
              //去除网格线
              show: false,
            },
          },
          series: [
            {
              data: this.lineYData,
              type: 'line',
              smooth: false,
              showSymbol: false,
              areaStyle: {
                normal: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#63C4C7', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#fff', // 100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: '#fff',
                  lineStyle: {
                    color: '#299497',
                  },
                },
                emphasis: {
                  // 鼠标经过时：
                  color: '#377CFF',
                },
              },
            },
          ],
        },
        true
      );
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions();
    },
  },
  watch: {
    lineXData: {
      deep: true,
      handler(newvalue, oldvalue) {
        if (newvalue) {
          this.initChart();
        }
      },
    },
  },
};
</script>
  